import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M4 6.25a4 4 0 1 1 7.955.603c-.126.832-.679 1.564-1.39 2.413L8 12.33 5.434 9.266c-.71-.85-1.263-1.581-1.389-2.413A4.038 4.038 0 0 1 4 6.25Zm4-5.5a5.5 5.5 0 0 0-5.438 6.327c.197 1.307 1.045 2.342 1.722 3.151L8 14.668l3.716-4.44c.677-.809 1.525-1.844 1.722-3.151A5.5 5.5 0 0 0 8 .75ZM8 4a.75.75 0 0 1 .75.75v1h1a.75.75 0 0 1 0 1.5h-1v1a.75.75 0 0 1-1.5 0v-1h-1a.75.75 0 0 1 0-1.5h1v-1A.75.75 0 0 1 8 4Z';
const draw24px =
  'M12 2.75a6.75 6.75 0 0 0-6.598 8.182c.217 1.003.847 1.895 1.619 2.833L12 19.82l4.98-6.054c.77-.938 1.401-1.83 1.618-2.833A6.75 6.75 0 0 0 12 2.75ZM3.75 9.5a8.25 8.25 0 1 1 16.314 1.75c-.3 1.385-1.146 2.52-1.926 3.468L12 22.181l-6.138-7.463c-.78-.949-1.627-2.083-1.926-3.469A8.279 8.279 0 0 1 3.75 9.5ZM12 6.25a.75.75 0 0 1 .75.75v2.25H15a.75.75 0 0 1 0 1.5h-2.25V13a.75.75 0 0 1-1.5 0v-2.25H9a.75.75 0 0 1 0-1.5h2.25V7a.75.75 0 0 1 .75-.75Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const MarkupPinIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'markupPin'),
) as IconWithRender;

MarkupPinIcon.displayName = 'MarkupPinIcon';
MarkupPinIcon.propTypes = Icon.propTypes;
MarkupPinIcon.renderIcon = (props) => <MarkupPinIcon {...props} />;
export default MarkupPinIcon;
